import { useEffect, useState } from 'react';

export default function useElementSize(targetRef) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const el = targetRef.current;
    if (!el) {
      return;
    }

    let animationFrameId = null;

    const update = () => {
      animationFrameId = null;
      const rect = el.getBoundingClientRect();
      const width = Math.max(0, Math.floor(rect.width));
      const height = Math.max(0, Math.floor(rect.height));

      setSize((currentSize) => {
        if (currentSize.width === width && currentSize.height === height) {
          return currentSize;
        }

        return {width, height};
      });
    };

    // Coalesce observer/window notifications and keep React updates outside the
    // ResizeObserver delivery cycle so resizing the canvas cannot feed back synchronously.
    const scheduleUpdate = () => {
      if (animationFrameId !== null) {
        return;
      }

      animationFrameId = window.requestAnimationFrame(update);
    };

    update();

    const ro = new ResizeObserver(scheduleUpdate);
    ro.observe(el);

    window.addEventListener('orientationchange', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);

    return () => {
      ro.disconnect();
      window.removeEventListener('orientationchange', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);

      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, [targetRef]);

  return size;
}
